/**
 * Цвета банды — тот же контракт, что у профиля (docs/team.md, раздел 3):
 * nick / bg / bg2 / accent / avatar_frame / card_bg / content_bg /
 * text_secondary + bg_angle, значение null означает «цвет стандартной темы».
 *
 * Поэтому утилиты не дублируются, а переиспользуются из
 * features/profile/utils/profileColors.js — один источник правды для
 * контрастов, градиентов и фолбэков темы.
 */

import { accentColor, cardPrimaryColor, contentBgColor, contrastRatio } from '../../profile/utils/profileColors'

export const toneBadgeStyle = (tones, colors) => {
  const background = contentBgColor(colors)
  const primary = cardPrimaryColor(colors)
  const color = tones.find((tone) => contrastRatio(tone, background) >= 4.5) || primary
  return { color, backgroundColor: `${color}14`, borderColor: `${color}66` }
}

export const roleBadgeStyle = (role, colors) => {
  const tones = {
    owner: ['#FACC15', '#92400E'],
    deputy: [accentColor(colors)],
    moderator: ['#4DDCFF', '#075985'],
    member: [cardPrimaryColor(colors)]
  }
  return toneBadgeStyle(tones[role] || tones.member, colors)
}

export {
  PROFILE_THEME as TEAM_THEME,
  COLOR_KEYS,
  isValidHex,
  normalizeHex,
  luminance,
  contrastRatio,
  profileBackground as teamPageBackground,
  primaryTextColor,
  secondaryTextColor,
  accentColor,
  lightenHex,
  nickColor,
  CARD_TEXT,
  CARD_SECONDARY,
  cardNickColor,
  contentBgColor,
  tileBgColor,
  cardSecondaryColor,
  cardPrimaryColor
} from '../../profile/utils/profileColors'
